var _path, _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 16.5C32.5 25.3365 25.3365 32.5 16.5 32.5C7.66343 32.5 0.5 25.3365 0.5 16.5C0.5 7.66343 7.66343 0.5 16.5 0.5C25.3365 0.5 32.5 7.66343 32.5 16.5Z",
    fill: "#CCE9E8",
    stroke: "#0BAFBF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.7447,
    y: 14.0425,
    width: 3.51064,
    height: 13.2,
    rx: 0.702128,
    fill: "#0BAFBF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 9.12768,
    r: 2.10638,
    fill: "#0BAFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoBlue);
export default __webpack_public_path__ + "static/media/Icon_Info_Blue.2d6b139da633fdbe1d09710735ccbc1e.svg";
export { ForwardRef as ReactComponent };